import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import classNames from 'classnames/bind';
import omit from 'lodash/omit';
import React from 'react';
import Tooltip from './Tooltip.js';
import '@babel/runtime-corejs3/core-js-stable/instance/fill';
import IcQMark from '../icons/IcQMark.js';
import { FOOTER_TYPE, FOOTER_QUICK_MENU_TITLE } from '../../constants/footer.js';
import { URL } from '../../constants/url.js';
import COLOR from '../../foundation/color.js';
import { getFooterServiceUrl } from '../../utils/index.js';
import style from './FooterQuickMenu.module.scss.js';

var _excluded = ["title", "isBold", "href", "tooltipInfo", "onClick", "onClickLogin", "onClickLogout"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context6, _context7; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context6 = ownKeys(Object(t), !0)).call(_context6, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context7 = ownKeys(Object(t))).call(_context7, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cx = _bindInstanceProperty(classNames).call(classNames, style);
var FOOTER_QUICK_MENU_MAP = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, FOOTER_TYPE.MY_ASSET, [{
  title: FOOTER_QUICK_MENU_TITLE.SHOPPING_PAY_HELP,
  href: URL.SHOPPING_PAY_HELP
}, {
  title: FOOTER_QUICK_MENU_TITLE.TERMS_POLICY,
  href: URL.TERMS_POLICY
}, {
  title: FOOTER_QUICK_MENU_TITLE.PRIVACY,
  isBold: true,
  href: URL.PRIVACY
}, {
  title: FOOTER_QUICK_MENU_TITLE.CREDIT_INFO_USAGE,
  href: URL.CREDIT_INFO_USAGE
}, {
  title: FOOTER_QUICK_MENU_TITLE.NPAY_AD_POINT,
  href: URL.NPAY_AD_POINT
}]), FOOTER_TYPE.PAYMENT, [{
  title: FOOTER_QUICK_MENU_TITLE.SHOPPING_PAY_HELP,
  href: URL.SHOPPING_PAY_HELP
}, {
  title: FOOTER_QUICK_MENU_TITLE.TERMS_POLICY,
  href: URL.TERMS_POLICY
}, {
  title: FOOTER_QUICK_MENU_TITLE.PRIVACY,
  isBold: true,
  href: URL.PRIVACY
}, {
  title: FOOTER_QUICK_MENU_TITLE.CREDIT_INFO_USAGE,
  href: URL.CREDIT_INFO_USAGE
}, {
  title: FOOTER_QUICK_MENU_TITLE.NPAY_AD_POINT,
  href: URL.NPAY_AD_POINT
}]), FOOTER_TYPE.SAVINGS, [{
  title: FOOTER_QUICK_MENU_TITLE.INDEMNIFICATION_PROVISION,
  tooltipInfo: {
    icon: /*#__PURE__*/React.createElement(IcQMark, {
      width: 16,
      height: 16,
      fill: COLOR.gray700.color
    }),
    contents: [{
      title: FOOTER_QUICK_MENU_TITLE.INDEMNIFICATION_PROVISION,
      description: ( /*#__PURE__*/React.createElement(React.Fragment, null, "\uB124\uC774\uBC84\uD30C\uC774\uB0B8\uC15C(\uC8FC)\uC774 \uC81C\uACF5\uD558\uB294 \uAE08\uC735\uC815\uBCF4\uB294 \uAC01 \uCEE8\uD150\uCE20 \uC81C\uACF5\uC5C5\uCCB4\uB85C\uBD80\uD130 \uBC1B\uB294 \uC815\uBCF4\uB85C \uD22C\uC790 \uCC38\uACE0\uC0AC\uD56D\uC774\uBA70, \uC624\uB958\uAC00 \uBC1C\uC0DD\uD558\uAC70\uB098 \uC9C0\uC5F0\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uB124\uC774\uBC84\uD30C\uC774\uB0B8\uC15C(\uC8FC)\uC740 \uC81C\uACF5\uB41C \uC815\uBCF4\uC5D0 \uC758\uD55C \uD22C\uC790\uACB0\uACFC\uC5D0 \uBC95\uC801\uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uAC8C\uC2DC\uB41C \uC815\uBCF4\uB294 \uBB34\uB2E8\uC73C\uB85C \uBC30\uD3EC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4."))
    }]
  }
}, {
  title: FOOTER_QUICK_MENU_TITLE.SAVINGS_INTEREST_RATE_INFO,
  href: URL.SAVINGS_INTEREST_RATE_INFO
}]), FOOTER_TYPE.CARD, [{
  title: FOOTER_QUICK_MENU_TITLE.INDEMNIFICATION_PROVISION,
  tooltipInfo: {
    icon: /*#__PURE__*/React.createElement(IcQMark, {
      width: 16,
      height: 16,
      fill: COLOR.gray700.color
    }),
    contents: [{
      title: FOOTER_QUICK_MENU_TITLE.INDEMNIFICATION_PROVISION,
      description: ( /*#__PURE__*/React.createElement(React.Fragment, null, "\uB124\uC774\uBC84\uD30C\uC774\uB0B8\uC15C(\uC8FC)\uC774 \uC81C\uACF5\uD558\uB294 \uAE08\uC735\uC815\uBCF4\uB294 \uAC01 \uCEE8\uD150\uCE20 \uC81C\uACF5\uC5C5\uCCB4\uB85C\uBD80\uD130 \uBC1B\uB294 \uC815\uBCF4\uB85C \uD22C\uC790 \uCC38\uACE0\uC0AC\uD56D\uC774\uBA70, \uC624\uB958\uAC00 \uBC1C\uC0DD\uD558\uAC70\uB098 \uC9C0\uC5F0\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uB124\uC774\uBC84\uD30C\uC774\uB0B8\uC15C(\uC8FC)\uC740 \uC81C\uACF5\uB41C \uC815\uBCF4\uC5D0 \uC758\uD55C \uD22C\uC790\uACB0\uACFC\uC5D0 \uBC95\uC801\uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uAC8C\uC2DC\uB41C \uC815\uBCF4\uB294 \uBB34\uB2E8\uC73C\uB85C \uBC30\uD3EC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4."))
    }]
  }
}]), FOOTER_TYPE.INSURANCE, []), FOOTER_TYPE.LOAN, [{
  title: FOOTER_QUICK_MENU_TITLE.LOAN_SOLICITATION_TERMS,
  href: URL.LOAN_SOLICITATION_TERMS
}]), FOOTER_TYPE.STOCK, [{
  title: FOOTER_QUICK_MENU_TITLE.STOCK_NOTICE,
  href: URL.STOCK.NOTICE
}, {
  title: FOOTER_QUICK_MENU_TITLE.STOCK_HELP,
  href: URL.STOCK.HELP
}, {
  title: FOOTER_QUICK_MENU_TITLE.TERMS_POLICY,
  href: URL.TERMS_POLICY
}, {
  title: FOOTER_QUICK_MENU_TITLE.PRIVACY,
  isBold: true,
  href: URL.PRIVACY
}, {
  title: FOOTER_QUICK_MENU_TITLE.STOCK_ERROR_REPORT,
  href: URL.STOCK.ERROR_REPORT
}]), FOOTER_TYPE.REAL_ESTATE, [{
  title: FOOTER_QUICK_MENU_TITLE.REAL_ESTATE_HELP,
  href: URL.REAL_ESTATE_HELP
}, {
  title: FOOTER_QUICK_MENU_TITLE.NAVER_FINANCIAL_TERMS_POLICY,
  href: URL.TERMS_POLICY
}, {
  title: FOOTER_QUICK_MENU_TITLE.PRIVACY,
  isBold: true,
  href: URL.PRIVACY
}]);
var getFooterQuickMenu = function getFooterQuickMenu(type, isLogin, isMobile) {
  var _context;
  var loginLogoutMenu = {
    title: isLogin ? FOOTER_QUICK_MENU_TITLE.LOGOUT : FOOTER_QUICK_MENU_TITLE.LOGIN,
    href: '#'
  };
  var allServiceMenu = {
    title: FOOTER_QUICK_MENU_TITLE.ALL_SERVICE,
    href: isMobile ? URL.ALL_SERVICES.MOBILE : URL.ALL_SERVICES.PC
  };
  var menus = FOOTER_QUICK_MENU_MAP[type];
  return _concatInstanceProperty(_context = [loginLogoutMenu, allServiceMenu]).call(_context, _toConsumableArray(menus));
};
function FooterQuickMenu(_ref) {
  var _context2;
  var type = _ref.type,
    isLogin = _ref.isLogin,
    isMobile = _ref.isMobile,
    _ref$overwriteMenuLis = _ref.overwriteMenuList,
    overwriteMenuList = _ref$overwriteMenuLis === void 0 ? [] : _ref$overwriteMenuLis,
    overrideMenuItem = _ref.overrideMenuItem,
    openNewWindow = _ref.openNewWindow;
  var list = (overwriteMenuList === null || overwriteMenuList === void 0 ? void 0 : overwriteMenuList.length) > 0 ? overwriteMenuList : _mapInstanceProperty(_context2 = getFooterQuickMenu(type, isLogin, isMobile)).call(_context2, function (item) {
    return _objectSpread(_objectSpread({}, item), overrideMenuItem === null || overrideMenuItem === void 0 ? void 0 : overrideMenuItem[item.title]);
  });
  var handleLogin = function handleLogin(event) {
    event.preventDefault();
    if (!isLogin) {
      var _context3;
      window.location.href = _concatInstanceProperty(_context3 = "https://nid.naver.com/nidlogin.login?".concat(isMobile ? 'svctype=262144&' : '', "url=")).call(_context3, encodeURIComponent(window.location.href));
    }
  };
  var handleLogout = function handleLogout(event) {
    event.preventDefault();
    if (isLogin) {
      if (window.confirm('로그아웃 하시겠습니까?')) {
        var _context4;
        window.location.href = _concatInstanceProperty(_context4 = "https://nid.naver.com/nidlogin.logout?".concat(isMobile ? 'svctype=262144&' : '', "url=")).call(_context4, encodeURIComponent(window.location.href));
      }
    }
  };
  return /*#__PURE__*/React.createElement("ul", {
    className: cx('article')
  }, _mapInstanceProperty(list).call(list, function (item) {
    var _context5;
    var title = item.title,
      isBold = item.isBold,
      href = item.href,
      tooltipInfo = item.tooltipInfo,
      onClick = item.onClick,
      onClickLogin = item.onClickLogin,
      onClickLogout = item.onClickLogout,
      rest = _objectWithoutProperties(item, _excluded);
    var isLoginLogout = _includesInstanceProperty(_context5 = ['로그인', '로그아웃']).call(_context5, title);
    var handleClickMenu = function handleClickMenu(e) {
      onClick && onClick(e);
      if (isLoginLogout) {
        isLogin ? (onClickLogout !== null && onClickLogout !== void 0 ? onClickLogout : handleLogout)(e) : (onClickLogin !== null && onClickLogin !== void 0 ? onClickLogin : handleLogin)(e);
      }
    };
    var menuClassName = cx('link', {
      'type-bold': isBold
    });
    return /*#__PURE__*/React.createElement("li", {
      key: "footer-quick-menu-".concat(title),
      className: cx('item', {
        'type-tooltip': tooltipInfo
      })
    }, href ? ( /*#__PURE__*/React.createElement("a", _objectSpread({
      href: getFooterServiceUrl(href),
      className: menuClassName,
      onClick: handleClickMenu,
      target: openNewWindow ? '_blank' : '_self',
      rel: openNewWindow ? 'noreferrer noopener' : undefined
    }, omit(rest, ['className'])), title)) : ( /*#__PURE__*/React.createElement("span", {
      className: menuClassName
    }, title)), tooltipInfo && ( /*#__PURE__*/React.createElement("div", {
      className: cx('area-button')
    }, /*#__PURE__*/React.createElement(Tooltip.Button, {
      tooltip: {
        contents: tooltipInfo === null || tooltipInfo === void 0 ? void 0 : tooltipInfo.contents,
        position: 'bottom',
        articleClassName: cx('tooltip')
      }
    }, tooltipInfo === null || tooltipInfo === void 0 ? void 0 : tooltipInfo.icon))));
  }));
}

export { FooterQuickMenu as default };
